import Link from "next/link";
import React from "react";

const CookiePolicy = () => {
  return (
    <div className="p-4 bg-white  sm:p-8">
      <div className="max-w-4xl p-6 mx-auto text-gray-700 sm:p-8">
        <div className="pb-4 mb-6 text-center border-b">
          <p className="text-sm text-gray-500">Current as of 20 Jan 2024</p>
          <h1 className="mt-2 text-2xl font-semibold text-gray-800 sm:text-3xl">
            Thrive Cookie Policy
          </h1>
          <p className="mt-4 text-sm text-gray-600">
            This Cookie Policy describes how Thrive Agric Limited ("Thrive
            Agric") uses "cookies" and other similar technologies, in connection
            with our Website. For any Thrive-affiliated websites, you can learn
            more about cookies by visiting those sites directly.
          </p>
        </div>

        <div className="mb-6">
          <h2 className="text-lg font-semibold text-gray-800">
            1. What is a Cookie?
          </h2>
          <p className="mt-2 text-gray-600">
            Cookies are small text files that are stored in a computer's browser
            directory. Cookies help site providers with things like
            understanding how people use a site, remembering a User's login
            details, and storing site preferences. Thrive Agric uses cookies as
            well as similar technologies (e.g., URL tracking, local storage).
            For the purpose of this Cookie Policy, such technologies are
            included in the term 'cookies'.
          </p>
        </div>

        <div className="mb-6">
          <h2 className="text-lg font-semibold text-gray-800">
            2. Does ThriveAgric use Cookies?
          </h2>
          <p className="mt-2 text-gray-600">
            Yes. We use cookies in accordance with our Privacy Policy to:
          </p>
          <ul className="pl-6 mt-2 space-y-1 text-gray-600 list-disc">
            <li>Ensure that our services function properly.</li>
            <li>
              Detect and prevent fraud and violations of our terms of service.
            </li>
            <li>Understand how visitors use and engage with our Site.</li>
            <li>Advertise our products and services, where allowed.</li>
            <li>
              Analyze and improve our services and your experience on the
              Website including improved relevancy and navigation, customizing
              your user experience, and curating content about Thrive Agric.
            </li>
          </ul>
        </div>

        <div className="mb-6">
          <h2 className="text-lg font-semibold text-gray-800">
            3. Who Sets Cookies When I Use ThriveAgric's Site?
          </h2>
          <p className="mt-2 text-gray-600">
            There are two main types of cookies that can be set:
          </p>
          <ul className="pl-6 mt-2 space-y-1 text-gray-600 list-disc">
            <li>
              <span className="font-semibold">First-party cookies:</span> these
              cookies are placed and read by ThriveAgric directly when you use
              our services.
            </li>
            <li>
              <span className="font-semibold">Third-party cookies:</span> these
              cookies are not set by ThriveAgric but by other companies, like
              Google or Facebook, for site analytics purposes.
            </li>
          </ul>
        </div>

        <div className="mb-6">
          <h2 className="text-lg font-semibold text-gray-800">
            4. How ThriveAgric Uses Cookies
          </h2>
          <p className="mt-2 text-gray-600">
            Cookies play an important role in helping us provide effective and
            safe Services. Below is a description of the commonly used cookie
            types and the purposes that apply to them.
          </p>

          <div className="mt-4">
            <h3 className="font-semibold text-gray-700 text-md">
              Essential Cookies
            </h3>
            <p className="mt-2 text-gray-600">
              These are cookies which we consider to be essential to the
              operation of our Website. We may use these cookies to:
            </p>
            <ul className="pl-6 mt-2 space-y-1 text-gray-600 list-disc">
              <li>Authenticate your session to remember your login state.</li>
              <li>
                Detect fraud and monitor potentially harmful or illegal use.
              </li>
              <li>Keep our Site and Services secure and operational.</li>
            </ul>
          </div>

          <div className="mt-4">
            <h3 className="font-semibold text-gray-700 text-md">
              Functional Cookies
            </h3>
            <p className="mt-2 text-gray-600">
              These cookies provide enhanced functions, performance, and
              services beyond essential operations. Examples include:
            </p>
            <ul className="pl-6 mt-2 space-y-1 text-gray-600 list-disc">
              <li>Remembering your site preferences and settings.</li>
              <li>Improving and analyzing the performance of our services.</li>
              <li>
                Collecting data via analytics tools like Google Analytics.
              </li>
            </ul>
          </div>

          <div className="mt-4">
            <h3 className="font-semibold text-gray-700 text-md">
              Advertising Cookies
            </h3>
            <p className="mt-2 text-gray-600">
              These cookies are used to deliver ads that are relevant to your
              interests on ThriveAgric and other websites.
            </p>
          </div>
        </div>

        <div>
          <h2 className="text-lg font-semibold text-gray-800">
            5. Can I opt-in and opt-out?
          </h2>
          <p className="mt-2 text-gray-600">
            Yes. ThriveAgric uses cookies in accordance with applicable law.
            ThriveAgric will ask for your prior consent before cookies are used,
            or offer you the option to opt-out of non-essential cookies. If you
            wish to opt-out, please send us an email via{" "}
            <Link
              href="mailto:info@thriveagric.com"
              className="text-[#48A928] underline"
            >
              info@thriveagric.com
            </Link>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;
